import Vue from 'vue';
import DateDropdown from '../components/common/date-dropdown';

Vue.component('DateDropdown', DateDropdown);
